// @flow

import React from 'react';
export function arrowABIcon() {
  return (
    <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6998 0C10.0923 0 9.59982 0.492488 9.59982 1.1C9.59982 1.70752 10.0923 2.2 10.6998 2.2H12.4442L8.57375 6.07046L6.59487 3.6958C6.38884 3.44857 6.08488 3.30396 5.76308 3.30008C5.44128 3.29621 5.13392 3.43345 4.92199 3.67565L1.07199 8.07566C0.671935 8.53286 0.718264 9.2278 1.17547 9.62785C1.63267 10.0279 2.32761 9.98157 2.72766 9.52437L5.72942 6.09378L7.65479 8.40421C7.85264 8.64164 8.14125 8.78488 8.44999 8.79888C8.75873 8.81289 9.05911 8.69637 9.27765 8.47783L13.9998 3.75565V5.50001C13.9998 6.10752 14.4923 6.60001 15.0998 6.60001C15.7073 6.60001 16.1998 6.10752 16.1998 5.50001V1.1C16.1998 0.492488 15.7073 0 15.0998 0H10.6998Z"
        fill="#5C5F62"
      />
    </svg>
  );
}
